<script>
const PRESETS = [
  { value: 5, label: '5 minutes avant' },
  { value: 15, label: '15 minutes avant' },
  { value: 30, label: '30 minutes avant' },
  { value: 60, label: '1 heure avant' },
  { value: 180, label: '3 heures avant' },
  { value: 1440, label: '1 jour avant' },
  { value: 2880, label: '2 jours avant' },
];

const DEFAULT_OFFSETS = [1440, 60];

export default {
  name: 'RemindersManager',
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    reminders: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      presets: PRESETS,
    };
  },
  methods: {
    onToggle(value) {
      this.$emit('update:enabled', value);
      if (value && this.reminders.length === 0) {
        this.$emit('update:reminders', [...DEFAULT_OFFSETS]);
      }
    },
    isUsed(value, index) {
      return this.reminders.some((offset, i) => i !== index && offset === value);
    },
    onChange(index, value) {
      const offset = Number(value);
      if (this.isUsed(offset, index)) {
        return;
      }
      const next = [...this.reminders];
      next[index] = offset;
      this.$emit('update:reminders', next);
    },
    addReminder() {
      if (this.reminders.length >= 5) {
        return;
      }
      const unused = this.presets.find((p) => !this.reminders.includes(p.value));
      const valueToAdd = unused ? unused.value : this.presets[0].value;
      this.$emit('update:reminders', [...this.reminders, valueToAdd]);
    },
    removeReminder(index) {
      this.$emit('update:reminders', this.reminders.filter((_, i) => i !== index));
    },
  },
};
</script>

<template>
  <div>
    <b-checkbox :value="enabled" :disabled="disabled" @input="onToggle">
      Activer les rappels automatiques
    </b-checkbox>

    <div v-if="enabled" class="mt-4">
      <div
        v-for="(offset, index) in reminders"
        :key="index"
        class="is-flex is-align-items-center mb-3"
      >
        <b-select
          :value="offset"
          expanded
          :disabled="disabled"
          @input="(value) => onChange(index, value)"
        >
          <option
            v-for="preset in presets"
            :key="preset.value"
            :value="preset.value"
            :disabled="isUsed(preset.value, index)"
          >
            {{ preset.label }}
          </option>
        </b-select>
        <b-button
          v-if="!disabled"
          type="is-text"
          icon-left="trash"
          class="ml-2"
          @click="removeReminder(index)"
        />
      </div>

      <b-button
        v-if="!disabled"
        type="is-light"
        icon-left="plus"
        :disabled="reminders.length >= 5"
        @click="addReminder"
      >
        Ajouter un rappel
      </b-button>
    </div>
  </div>
</template>
